import Vue from 'vue'
import store from '../store'
import injector from 'vue-inject'

Vue.use(injector)

class Popup {
    /**
     * Show popup
     * @param message
     * @param button
     * @param reload
     */
    show (message, button, reload) {
        if (!button && !reload) {
            button = 'OK';
            reload = false;
        }

        store.commit('modals', {
            modal: 'alert',
            data: {
                visible : true,
                message : message,
                button  : button,
                reload  : reload
            }
        });
    }

    /**
     * Hide popup
     */
    hide () {
        store.commit('modals', {
            modal: 'alert',
            data: {
                visible: false,
                message: '',
                reload: false
            }
        });
    }
}

injector.service('popup', Popup);


// WEBPACK FOOTER //
// ./src/services/popup.js